/**
 * ATC / agent-runtime message shape (era-compatible flat struct).
 * Kept in the SDK so {@link Message.fromV1} can hydrate {@link Message} instances.
 */

export type CoteraPart = {
  type: 'text' | 'image' | 'file' | 'reasoning' | 'tool-call' | 'tool-result';
  text: string | null;
  image: {
    url: string | null;
    mimeType: string | null;
    data: string | null;
  } | null;
  file: {
    data: string | null;
    mimeType: string | null;
    filename: string | null;
  } | null;
  toolCall: {
    toolCallId: string;
    toolName: string;
    args: Record<string, unknown>;
  } | null;
  toolResult: {
    toolCallId: string;
    toolName: string;
    result: Record<string, unknown>;
  } | null;
};

export type CoteraAgentMessage = {
  id?: string;
  role: 'user' | 'assistant' | 'system' | 'tool';
  content: CoteraPart[];
};

export function makeCoteraPart(
  part: Partial<CoteraPart> & { type: CoteraPart['type'] }
): CoteraPart {
  return {
    text: null,
    image: null,
    file: null,
    toolCall: null,
    toolResult: null,
    ...part,
  };
}
